import { routes as Home } from '@/views/home/index.js'
import { routes as Courses } from '@/views/courses/index.js'
import { routes as Users } from '@/views/users/index.js'
import { routes as IncomeTax } from '@/views/users/incomeTax/index.js'
import { routes as SendedCi } from '@/views/ci/sended/index.js'
import { routes as ReceivedCi } from '@/views/ci/received/index.js'
import { routes as AllCi } from '@/views/ci/all/index.js'

export default [
  {
    path: '/',
    name: 'dashboard',
    redirect: '/home',
    component: () => import('./Dashboard.vue'),
    meta: {
      name: 'Dashboard',
      auth: true,
      user: 'Admin',
    },
    children: [...Home, ...Courses, ...Users, ...SendedCi, ...ReceivedCi, ...AllCi, ...IncomeTax],
  },
]
